import React from 'react';

const PARTNER_EXAMPLES = [
  ['Realtors', 'Closing gifts'],
  ['Mortgage brokers', 'New-home celebrations'],
  ['Financial advisors', 'Client appreciation'],
  ['Airbnb hosts', 'Guest welcome bottles'],
  ['Builders', 'Homeowner handovers'],
  ['Businesses', 'Employee & client gifts'],
  ['Event professionals', 'Weddings & events'],
];

const CorpPartnerSection = ({ onPartner, onPlanning }) => (
  <section className="ff-section" data-testid="corp-partner" style={{ background: 'var(--ff-brown)', color: 'var(--ff-cream)' }}>
    <div className="ff-container" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 40, alignItems: 'center' }}>
      <div>
        <p className="ff-eyebrow" style={{ color: 'var(--ff-gold)' }}>THE LOKAL PARTNER PROGRAM</p>
        <h2 style={{ color: 'var(--ff-cream)', textAlign: 'left' }}>Become a Lokal Partner.</h2>
        <p style={{ fontSize: 18, lineHeight: 1.6, opacity: 0.92, margin: '0 0 14px' }}>
          If wine could become part of your client experience, we'd love to work with you.
        </p>
        <p style={{ fontSize: 15, lineHeight: 1.7, opacity: 0.8, margin: 0 }}>
          For professionals who regularly celebrate clients, customers, employees or
          guests — we keep your label on file, hold your preferences, and make every
          reorder effortless. Think of us as your ongoing gifting partner, not a
          one-time wine purchase.
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 28 }}>
          <button className="ff-btn ff-btn-gold ff-btn-lg" data-testid="corp-partner-cta" onClick={onPartner}>
            Become a Lokal Partner
          </button>
          <button
            className="ff-btn ff-btn-lg"
            data-testid="corp-partner-planning"
            onClick={onPlanning}
            style={{ background: 'transparent', color: 'var(--ff-cream)', border: '2px solid rgba(245,235,220,0.5)' }}
          >
            Tell Us What You're Planning
          </button>
        </div>
      </div>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: 10 }}>
        {PARTNER_EXAMPLES.map(([who, what]) => (
          <li key={who} style={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12,
            padding: '12px 16px', borderRadius: 8,
            background: 'rgba(245,235,220,0.06)', border: '1px solid rgba(201,169,97,0.25)',
            fontSize: 15,
          }}>
            <span style={{ fontWeight: 600 }}>{who}</span>
            <span style={{ color: 'var(--ff-gold)' }}>→</span>
            <span style={{ opacity: 0.85, textAlign: 'right' }}>{what}</span>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default CorpPartnerSection;
